module.exports = __webpack_public_path__ + "img/angststoerungen_1920.65e38ff0.webp";